function AlphaIntro() {
  return (
    <div className='text-center mb-5'>
      <h3 className='accent'>Полезные ссылки:</h3>
      <li><a href="https://forms.gle/wuLnyaDSHew52Ec49" target="_blank" rel="noopener noreferrer">Рассылка по моим курсам и проектам</a></li>
      <li><a href="https://javascript-universe.netlify.app/quiz/quiz" target="_blank" rel="noopener noreferrer">Проверь свой уровень английского</a></li>
      <li><a href="https://job-hunt-webinars.netlify.app/index-ru" target="_blank" rel="noopener noreferrer">Курс по поиску работы разработчиком в США</a></li>
      <li><a href="https://www.instagram.com/english.witch.elena/" target="_blank" rel="noopener noreferrer">Инстаграм с уроками английского</a></li>
      <li><a href="https://t.me/english_witch_elena" target="_blank" rel="noopener noreferrer">Телеграм с уроками английского</a></li>
      <li><a href="https://www.instagram.com/elena_in_america/" target="_blank" rel="noopener noreferrer">Мой личный Инстаграм</a></li>
      <li><a href="https://t.me/elena_in_america" target="_blank" rel="noopener noreferrer">Мой личный Телеграм</a></li>
    </div>
  )
}

export default AlphaIntro;